module.exports = __webpack_public_path__ + "img/Copyright_pic08.939faa29.jpg";